import { render, staticRenderFns } from "./VacancyStepWizardCommon.vue?vue&type=template&id=66f862f6&scoped=true&"
import script from "./VacancyStepWizardCommon.vue?vue&type=script&lang=js&"
export * from "./VacancyStepWizardCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f862f6",
  null
  
)

/* custom blocks */
import block0 from "./VacancyStepWizardCommon.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyStepWizardCommon.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
